import { MoreVertical } from "lucide-react";

import type { ResponsiveAction } from "./types";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown";

interface OverflowMenuProps {
  actions: ResponsiveAction[];
  align?: "start" | "center" | "end";
}

const OverflowMenu = ({ actions, align = "end" }: OverflowMenuProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        aria-label="More actions"
      >
        <MoreVertical className="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align={align} className="min-w-[12rem]">
      {actions.map(action => (
        <DropdownMenuItem
          key={action.id}
          disabled={action.disabled}
          onSelect={() => {
            action.onClick?.();
          }}
          className="cursor-pointer gap-2"
        >
          {action.icon ? (
            <span className="inline-flex h-4 w-4 shrink-0 items-center [&>svg]:h-4 [&>svg]:w-4">
              {action.icon}
            </span>
          ) : null}
          <span>{action.label}</span>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default OverflowMenu;
